
import { defineComponent } from "vue";
import { Button } from "@progress/kendo-vue-buttons";
import { useI18n } from 'vue-i18n'

/**
 * Reusable button component
 * Wrapper for kendo-ui button component
 *
 * reference: https://www.telerik.com/kendo-vue-ui/components/buttons/api/ButtonProps/
 */

export default defineComponent({
  name: "IButton",
  components: {
    kbutton: Button,
  },
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return { t };
  },
  props: {
    themeColor: {
      type: String,
      default: 'primary'
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
